module.exports = __webpack_public_path__ + "img/key.09172b40.svg";